var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4918 0.523784C17.0417 0.0617383 16.3754 -0.110397 15.7541 0.070798L1.2672 4.28357C0.611729 4.46567 0.147138 4.98842 0.0219871 5.6525C-0.105865 6.32835 0.340718 7.18631 0.924156 7.54507L5.45391 10.3291C5.9185 10.6145 6.51815 10.5429 6.9026 10.1552L12.0896 4.93587C12.3507 4.66408 12.7829 4.66408 13.044 4.93587C13.3051 5.1986 13.3051 5.62441 13.044 5.8962L7.84799 11.1164C7.46263 11.5033 7.3906 12.1057 7.67422 12.5732L10.442 17.1484C10.7661 17.692 11.3243 18 11.9366 18C12.0086 18 12.0896 18 12.1617 17.9909C12.8639 17.9003 13.4222 17.4202 13.6293 16.7407L17.924 2.27231C18.1131 1.65625 17.942 0.985831 17.4918 0.523784Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.b77545922018fa80227dc770701114c8.svg";
export { ForwardRef as ReactComponent };